/* ============================================================================
   VF → Rebuy Smart Cart Bridge
   Hijacks ALL native cart-open vectors so only Rebuy's cart ever shows.
   Drop into assets/script-rebuy-cart.js, load BEFORE script-product.js.
   ============================================================================ */
(function () {
  "use strict";

  /* ------------------------------------------------------------------
     1. NATIVE CART — remove from DOM entirely
     app.js builds the cart-drawer dynamically, so hiding isn't enough.
     We remove every instance and watch for new ones.
     ------------------------------------------------------------------ */
  function killNativeCart() {
    document.querySelectorAll(".cart-drawer").forEach(function (el) {
      el.remove();
    });
    document.body.classList.remove("overflow-hidden");
  }

  // Run immediately
  killNativeCart();

  // Watch for app.js re-creating it
  new MutationObserver(function () {
    if (document.querySelector(".cart-drawer")) {
      killNativeCart();
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ------------------------------------------------------------------
     2. REBUY CART — open helper with retry
     ------------------------------------------------------------------ */
  function openRebuyCart() {
    killNativeCart();

    // Rebuy's API isn't always ready immediately
    var attempts = 0;
    var maxAttempts = 20; // 2 seconds total

    function tryOpen() {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === "function") {
        window.Rebuy.SmartCart.show();
        return;
      }
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.show === "function") {
        window.Rebuy.Cart.show();
        return;
      }
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tryOpen, 100);
      } else {
        console.warn("[VF] Rebuy cart API not found after retries.");
      }
    }

    tryOpen();
  }

  /* ------------------------------------------------------------------
     3. INTERCEPT ALL CART-OPEN TRIGGERS
     Uses capture phase (3rd arg = true) so we fire before any theme
     handler, regardless of load order.
     ------------------------------------------------------------------ */

  // 3a. Header cart icon / any .show-cart-drawer trigger
  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest(".show-cart-drawer, [data-cart-trigger], .cart-icon-bubble, .header-cart-icon, a[href='/cart']");
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      openRebuyCart();
    },
    true // capture phase — fires before theme listeners
  );

  // 3b. Add-to-cart button on PDP
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(".add-to-cart-button");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantInput = document.querySelector('input[name="variant"]:checked') || document.querySelector('input[name="id"]');
      var variantID = variantInput ? variantInput.value : btn.getAttribute("data-variant-id");
      var qtyInput = document.querySelector(".product-qty");
      var quantity = qtyInput ? qtyInput.value : 1;
      var sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked');
      var sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

      if (!variantID) {
        console.warn("[VF] No variant ID found for add-to-cart.");
        return;
      }

      addItemToCart(variantID, quantity, sellingPlan);
    },
    true
  );

  // 3c. Quick-buy buttons (empty cart state, collection pages)
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(".quick-buy-button");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantID = btn.getAttribute("data-variant-id");
      if (variantID) {
        addItemToCart(variantID, 1);
      }
    },
    true
  );

  /* ------------------------------------------------------------------
     4. INTERCEPT THEME'S FETCH TO /cart/add.js
     Some themes open the cart drawer on a successful add-to-cart fetch
     response. Monkey-patch fetch to suppress the native cart if the
     request targets /cart/add.js.
     ------------------------------------------------------------------ */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var isCartAdd = typeof url === "string" && url.indexOf("/cart/add") !== -1;

    var result = originalFetch.apply(this, arguments);

    if (isCartAdd) {
      result.then(function () {
        // Give any chained .then() handlers 1 frame to fire,
        // then kill the native cart if it snuck open
        requestAnimationFrame(function () {
          killNativeCart();
        });
      });
    }

    return result;
  };

  /* ------------------------------------------------------------------
     5. INTERCEPT XMLHttpRequest to /cart/add.js
     The existing postAjax uses XHR, and the theme might too.
     ------------------------------------------------------------------ */
  var XHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
      this._isCartAdd = true;
    }
    return XHROpen.apply(this, arguments);
  };

  var XHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._isCartAdd) {
      this.addEventListener("load", function () {
        requestAnimationFrame(function () {
          killNativeCart();
        });
      });
    }
    return XHRSend.apply(this, arguments);
  };

  /* ------------------------------------------------------------------
     6. ADD-TO-CART API
     ------------------------------------------------------------------ */
  function addItemToCart(variantId, qty, sellingPlan) {
    var body = {
      id: Number(variantId),
      quantity: Number(qty) || 1,
    };
    if (sellingPlan != null && sellingPlan !== "" && !isNaN(Number(sellingPlan))) {
      body.selling_plan = Number(sellingPlan);
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || "Could not add to cart");
          });
        }
        return res.json();
      })
      .then(function () {
        // Rebuy auto-refreshes its cart on Shopify cart changes,
        // but we explicitly open it in case it was closed
        openRebuyCart();
      })
      .catch(function (err) {
        console.error("[VF] Add to cart error:", err);
        alert(err.message || "Could not add to cart");
      });
  }

  /* ------------------------------------------------------------------
     7. PUBLIC API (for other scripts that call CartApi)
     ------------------------------------------------------------------ */
  function postCartChange(line, quantity, callback) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ line: line, quantity: Number(quantity) }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            throw new Error((body && (body.description || body.message)) || "Could not update cart");
          }
          return body;
        });
      })
      .then(function () {
        if (callback) callback();
      })
      .catch(function (err) {
        console.error(err);
        alert(err.message || "Could not update cart");
      });
  }

  window.CartApi = {
    updateProductQuantity: function (line, qty) {
      postCartChange(line, qty);
    },
    deleteProductFromCart: function (line, cb) {
      postCartChange(line, 0, cb);
    },
    addItemToCart: addItemToCart,
  };
})();